module.exports = __webpack_public_path__ + "img/2.3ba868a8.png";